.fc{background-color:inherit;}